import { render, staticRenderFns } from "./GlobalFeed.vue?vue&type=template&id=43fc906c&"
import script from "./GlobalFeed.vue?vue&type=script&lang=js&"
export * from "./GlobalFeed.vue?vue&type=script&lang=js&"
import style0 from "./GlobalFeed.vue?vue&type=style&index=0&id=43fc906c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports